var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDnk = function SvgDnk(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#D80027",
    d: "M0 0h513v342H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M190 0h-60v140H0v60h130v142h60V200h323v-60H190z"
  })));
};
export { SvgDnk as ReactComponent };